import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Vuetify, {
  VApp,
  VToolbar,
  VContent,
  VIcon,
  VBtn,
  VContainer,
  VLayout,
  VFlex,
  VSpacer,
  VForm,
  VTextField,
  VProgressCircular,
  VAutocomplete,
  VFadeTransition,
  VAlert,
  VTextarea,
  VCheckbox,
  VSelect,
  VSnackbar
} from 'vuetify/lib'
import { Ripple } from 'vuetify/lib/directives'
import 'vuetify/src/stylus/app.styl'
import 'vuetify/dist/vuetify.min.css'

import VueResource from 'vue-resource'

import VueI18n from 'vue-i18n'
import en from './locale/en'
import es from './locale/es'

Vue.config.productionTip = false

Vue.use(Vuetify, {
  locale: (navigator.language || navigator.userLanguage).split('-')[0] === 'es' ? 'es' : 'en',
  theme: {
    primary: '#00D7D7',
    secondary: '#040729',
    accent: '#241DBA',
    error: '#D32F2F'
  },
  components: {
    VApp,
    VToolbar,
    VContent,
    VIcon,
    VBtn,
    VContainer,
    VLayout,
    VFlex,
    VSpacer,
    VForm,
    VTextField,
    VProgressCircular,
    VAutocomplete,
    VFadeTransition,
    VAlert,
    VTextarea,
    VCheckbox,
    VSelect,
    VSnackbar
  },
  directives: {
    Ripple
  }
})

Vue.use(VueResource)
Vue.http.interceptor.before = function (request, next) {
  next(response => {
    if (!response.ok) {
      store.commit('setMessage', { text: this.$t('message.error'), color: 'error', timeout: 10000 })
    }
  })
}

Vue.use(VueI18n)
const messages = {
  en,
  es
}
const i18n = new VueI18n({
  locale: (navigator.language || navigator.userLanguage).split('-')[0] === 'es' ? 'es' : 'en',
  messages
})

window.vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
